export default __webpack_public_path__ + "static/media/chat-icon-bottom-nav-mobile.c2b85eb1.webp";